<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <!-- <li>
            <a href="#">
              About Us
            </a>
          </li> -->
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }}
        <a href="https://ceelabs.com/" target="_blank"
          >Ceelabs s.r.o.</a>  v1.49.6
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
